import type { SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	JIRA_SERVICE_MANAGEMENT_APP_NAME,
	JIRA_PRODUCT_DISCOVERY_APP_NAME,
	JIRA_APP_NAME,
} from '@atlassian/jira-project-settings-apps-common/src/consts';
import {
	type Application,
	JIRA_CORE,
	JIRA_SERVICE_DESK,
	JIRA_SOFTWARE,
	JIRA_PRODUCT_DISCOVERY,
} from '@atlassian/jira-shared-types/src/application.tsx';

export const getApplicationName = (application: Application): string => {
	switch (application) {
		case JIRA_SOFTWARE:
			return JIRA_APP_NAME;
		case JIRA_SERVICE_DESK:
			return JIRA_SERVICE_MANAGEMENT_APP_NAME;
		case JIRA_CORE:
			return JIRA_APP_NAME;
		case JIRA_PRODUCT_DISCOVERY:
			return JIRA_PRODUCT_DISCOVERY_APP_NAME;
		default:
			throw new Error(`Unknown application type: ${application}`);
	}
};

export const fireAnalyticsBasedOnType =
	(type: string) => (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		if (type) {
			fireUIAnalytics(analyticsEvent, `permissionGated${type}`);
		}
	};
